"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var positions = {
  left: 'pp-start-form-wrapper-left',
  right: 'pp-start-form-wrapper-right'
};

var FloatingBox = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FloatingBox, _React$Component);

  var _super = _createSuper(FloatingBox);

  function FloatingBox() {
    var _this;

    (0, _classCallCheck2["default"])(this, FloatingBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      isActive: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggle", function () {
      _this.setState(function (prevState) {
        return {
          isActive: !prevState.isActive
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getActiveState", function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          props = _assertThisInitialize.props,
          state = _assertThisInitialize.state;

      return props.trigger ? state.isActive : props.isActive;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTitle", function () {
      var title = _this.props.title;
      if (!title) return null;

      if (typeof title === 'string') {
        return /*#__PURE__*/React.createElement("h1", null, title);
      }

      return title;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getTrigger", function () {
      var trigger = _this.props.trigger;

      if (trigger) {
        return /*#__PURE__*/React.cloneElement(trigger, {
          onClick: _this.toggle
        });
      }

      return null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getWrapper", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          footer = _this$props.footer,
          header = _this$props.header,
          icon = _this$props.icon,
          menu = _this$props.menu,
          onClose = _this$props.onClose,
          transition = _this$props.transition;

      var isActive = _this.getActiveState();

      var titleEl = _this.getTitle();

      var Component = _this.props.tag;
      return /*#__PURE__*/React.createElement(Component, {
        className: (0, _classnames["default"])('pp-start-form', {
          'pp-active': isActive
        }),
        style: transition && {
          bottom: -2360
        } || {}
      }, /*#__PURE__*/React.createElement("span", {
        className: "pp-action-close pp-ico-close",
        title: "Cancel",
        onClick: onClose || _this.toggle
      }), /*#__PURE__*/React.createElement("div", {
        className: "pp-body"
      }, /*#__PURE__*/React.createElement("span", {
        className: "pp-border-body"
      }), /*#__PURE__*/React.createElement("header", {
        className: "pp-start-form-header"
      }, icon && /*#__PURE__*/React.createElement(_Icon["default"], {
        className: icon
      }), titleEl, header && /*#__PURE__*/React.createElement("div", {
        className: "pp-header-options"
      }, header)), menu && /*#__PURE__*/React.createElement("div", {
        className: "pp-start-form-fields"
      }, menu), children), footer && /*#__PURE__*/React.createElement("footer", null, footer));
    });
    return _this;
  }

  (0, _createClass2["default"])(FloatingBox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var isActive = this.getActiveState();
      var onOpen = this.props.onOpen;

      if (onOpen && isActive) {
        onOpen();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var position = this.props.position;
      var triggerEl = this.getTrigger();
      var wrapperEl = this.getWrapper();
      return /*#__PURE__*/React.createElement("div", {
        className: (0, _classnames["default"])(positions[position] || positions.right)
      }, triggerEl, wrapperEl);
    }
  }]);
  return FloatingBox;
}(React.Component);

(0, _defineProperty2["default"])(FloatingBox, "defaultProps", {
  tag: 'div',
  transition: false,
  position: 'right'
});
var _default = FloatingBox;
exports["default"] = _default;